/**
 * @generated SignedSource<<12589e73ac9a162e518463a41a358ccd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountProfileSetLanguageMutation$variables = {
  language: string;
};
export type AccountProfileSetLanguageMutation$data = {
  readonly setInterfaceLanguage: {
    readonly learner: {
      readonly id: string;
      readonly interfaceLanguage: string | null | undefined;
      readonly interfaceLocale: string;
    } | null | undefined;
  };
};
export type AccountProfileSetLanguageMutation = {
  response: AccountProfileSetLanguageMutation$data;
  variables: AccountProfileSetLanguageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "language",
        "variableName": "language"
      }
    ],
    "concreteType": "SetInterfaceLanguagePayload",
    "kind": "LinkedField",
    "name": "setInterfaceLanguage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interfaceLanguage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interfaceLocale",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountProfileSetLanguageMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AccountProfileSetLanguageMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "49ed0f530cf55adae07ccc99ae25ed6a",
    "id": null,
    "metadata": {},
    "name": "AccountProfileSetLanguageMutation",
    "operationKind": "mutation",
    "text": "mutation AccountProfileSetLanguageMutation(\n  $language: String!\n) {\n  setInterfaceLanguage(language: $language) {\n    learner {\n      id\n      interfaceLanguage\n      interfaceLocale\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0abb5e8be2797042ed86b4614f747f9";

export default node;
